export { default as SlotDetail } from "./SlotDetail";

